import axios from "axios";
import React, { createContext, useContext, useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import { TostMessageContext } from "./TostMessage";

export const MenuContext = createContext();
// 12345678@Abc
export function MenuProvider({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <MenuContext.Provider
      value={{
        menuOpen,
        setMenuOpen
      }}
    >
      {children}
    </MenuContext.Provider>
  );
}
